// Admin: integration/SSO requests across all tenants (status='guided').
import { supabase } from '@govern360/shared';

export async function listIntegrationRequests() {
  const { data, error } = await supabase.rpc('staff_integration_requests');
  return { data: data || [], error };
}
export async function resolveIntegration(tenantId, provider, action) {
  // action: 'done' | 'dismiss'
  const { error } = await supabase.rpc('staff_resolve_integration', {
    p_tenant: tenantId, p_provider: provider, p_action: action,
  });
  return { error };
}
